var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b,.c{fill:#2148ff;}.b{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.602 3.494)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.959,1.89H2.836a.945.945,0,0,0-.945.945V14.178a.945.945,0,0,0,.945.945H17.959a.945.945,0,0,0,.945-.945V2.836A.945.945,0,0,0,17.959,1.89ZM2.836,0A2.836,2.836,0,0,0,0,2.836V14.178a2.836,2.836,0,0,0,2.836,2.836H17.959a2.836,2.836,0,0,0,2.836-2.836V2.836A2.836,2.836,0,0,0,17.959,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.836,1.418A1.418,1.418,0,1,1,1.418,0,1.418,1.418,0,0,1,2.836,1.418Z",
    transform: "translate(3.781 10.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.836,1.418A1.418,1.418,0,1,1,1.418,0,1.418,1.418,0,0,1,2.836,1.418Z",
    transform: "translate(8.507 10.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H20.794V1.89H0Z",
    transform: "translate(0 4.726)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.6deaaa5758194860d2ad6f4b4c9d093a.svg";
export { ForwardRef as ReactComponent };